import React from 'react';

import {createBottomTabNavigator} from '@react-navigation/bottom-tabs';
import {View, useWindowDimensions} from 'react-native';
import HuntPostCardAddressConfirm from '../ScavengerHunt_v2/HuntPostCardAddressConfirm';
////////////////////////
///////// components

//////////// header bar

import ClassicHuntHeaderTimer from 'src/HeaderComponents/ClassicHuntHeaderTimer';
import {MainIcon} from 'src/HeaderComponents/HeaderComponents';
import FoxShopIcon from 'src/HeaderComponents/FoxShopIcon';

import ScavengerHuntCharacterSelection from 'src/ScavengerHunt_v2/Lobby/CharacterSelection';
import ScavengerHuntGameLobby from 'src/ScavengerHunt_v2/Lobby/GameLobby';

import HuntPaused from 'src/ScavengerHunt_v2/HuntPaused';

import DelayedLoad from 'src/Nav/DelayedLoad';
///////////////////////////////
///////////////////////////////
///////////////// v2

import HuntLoading from 'src/ScavengerHunt_v2/HuntLoading';
import TeamPhoto from 'src/ScavengerHunt_v2/TeamPhoto';
import HuntTabNavigator from 'src/ScavengerHunt_v2/HuntTabNavigator';
import HuntIntro from 'src/ScavengerHunt_v2/Game/HuntIntro';
import HuntOutro from 'src/ScavengerHunt_v2/Game/HuntOutro';
import NavigationChallenge from 'src/ScavengerHunt_v2/Game/NavigationChallenge';
import NavigationScore from 'src/ScavengerHunt_v2/Game/NavigationScore';
import LocationChallengeScore from 'src/ScavengerHunt_v2/Game/LocationChallengeScore';
import LocationOutro from 'src/ScavengerHunt_v2/Game/LocationOutro';
import MainGameController from 'src/ScavengerHunt_v2/MainGameController';

import LocationComplete from 'src/ScavengerHunt_v2/Game/LocationComplete';

import PlayerDash from 'src/ScavengerHunt_v2/Game/PlayerDash';
import PlayerTreasureChallenges from 'src/ScavengerHunt_v2/Game/PlayerTreasureChallenges';

import HuntFinished from 'src/ScavengerHunt_v2/HuntFinished';
import HuntFinishedPlayer from 'src/ScavengerHunt_v2/HuntFinishedPlayer';

import HuntPhotos from 'src/ScavengerHunt_v2/HuntPhotos';

///////////////////////////////
///////////////////////////////
///////////////// classic
import ClassicChallenges from 'src/ScavengerHunt_v2/Classic/ClassicChallenges';
import HuntPostCard from '../ScavengerHunt_v2/HuntPostCard';
import {useSafeAreaInsets} from 'react-native-safe-area-context';
import FocusedWrapper from './FocusedWrapper';

import FullScreenNavigationHelpModal from '../ScavengerHunt_v2/Game/FullScreenNavgiationHelpModal';
import {dispatchAction} from '../Utils/helpers';
import {resetHomeView} from '../Redux/reducers/home.reducer';
import {useSelector} from 'react-redux';
import GameLobbyPlayers from '../ScavengerHunt_v2/Lobby/GameLobbyPlayers';
import {navigationRef} from './navigationHelpers';
import GameHeader from '../ScavengerHunt_v2/List/GameHeader';
import LocationChallenges from '../ScavengerHunt_v2/Game/LocationChallenges';

const Tab = createBottomTabNavigator();

const NavigationChallengeWrapper = () => {
  return (
    <FocusedWrapper>
      <NavigationChallenge />
    </FocusedWrapper>
  );
};

const LocationChallengeWrapper = () => {
  return (
    <FocusedWrapper>
      <LocationChallenges />
    </FocusedWrapper>
  );
};

const PlayerTreasureChallengesWrapper = () => {
  return (
    <FocusedWrapper>
      <PlayerTreasureChallenges />
    </FocusedWrapper>
  );
};

const HuntFinishedPlayerWrapper = () => {
  return (
    <FocusedWrapper>
      <HuntFinishedPlayer />
    </FocusedWrapper>
  );
};

const HuntPhotosWrapper = () => {
  return (
    <FocusedWrapper>
      <HuntPhotos />
    </FocusedWrapper>
  );
};

const PlayerDashWrapper = () => {
  return (
    <FocusedWrapper>
      <PlayerDash />
    </FocusedWrapper>
  );
};

const HuntPostCardWrapper = () => {
  return (
    <FocusedWrapper>
      <HuntPostCard />
    </FocusedWrapper>
  );
};

const TeamPhotoWrapper = () => {
  return (
    <FocusedWrapper>
      <TeamPhoto />
    </FocusedWrapper>
  );
};

const HuntOutroWrapper = () => {
  return (
    <FocusedWrapper>
      <HuntOutro />
    </FocusedWrapper>
  );
};

const LocationCompleteWrapper = () => {
  return (
    <FocusedWrapper>
      <LocationComplete />
    </FocusedWrapper>
  );
};

const ClassicChallengesWrapper = () => {
  return (
    <FocusedWrapper>
      <ClassicChallenges />
    </FocusedWrapper>
  );
};

const LocationOutroWrapper = () => {
  return (
    <FocusedWrapper>
      <LocationOutro />
    </FocusedWrapper>
  );
};

const LocationChallengeScoreWrapper = () => {
  return (
    <FocusedWrapper>
      <DelayedLoad delay={100}>
        <LocationChallengeScore />
      </DelayedLoad>
    </FocusedWrapper>
  );
};

const NavigationScoreWrapper = () => {
  return (
    <FocusedWrapper>
      <NavigationScore />
    </FocusedWrapper>
  );
};

const HuntIntroWrapper = () => {
  return (
    <FocusedWrapper>
      <HuntIntro />
    </FocusedWrapper>
  );
};

const HuntLoadingWrapper = () => {
  return (
    <FocusedWrapper>
      <HuntLoading />
    </FocusedWrapper>
  );
};

const ScavengerHuntGameLobbyWrapper = () => {
  return (
    <FocusedWrapper>
      <ScavengerHuntGameLobby />
    </FocusedWrapper>
  );
};

const ScavengerHuntCharacterSelectionWrapper = () => {
  return (
    <FocusedWrapper>
      <ScavengerHuntCharacterSelection />
    </FocusedWrapper>
  );
};

const FullScreenNavigationHelpModalWrapper = () => {
  return (
    <FocusedWrapper>
      <FullScreenNavigationHelpModal />
    </FocusedWrapper>
  );
};

const GameLobbyPlayerModal = () => <GameLobbyPlayers isModal />;

export default function ScavengerHuntGame_v2_header_wrapper() {
  const {height} = useWindowDimensions();
  const isCurrentScreenGameLobby = useSelector(
    (state) =>
      state.current_screen?.currentScreen == 'ScavengerHuntGameLobby' ||
      state.current_screen?.previousScreen == 'ScavengerHuntGameLobby',
  );

  const insets = useSafeAreaInsets();

  const useNewHeader = useSelector(
    (state) => state.current_screen?.currentScreen !== 'ScavengerHuntGameLobby',
  );
  return (
    <View
      style={{
        flex: 1,
        backgroundColor: 'white',
        // not using safe area with new header for fade over effect
        paddingTop: useNewHeader ? 0 : insets.top,
        paddingBottom: useNewHeader ? 0 : insets.bottom,
        height,
      }}>
      <Tab.Navigator
        tabBar={() => <HuntTabNavigator />}
        screenOptions={() => ({
          title: 'Home',
          headerTitleAlign: 'center',
          headerStyle: {
            elevation: 0, // remove shadow on Android
            shadowOpacity: 0, // remove shadow on iOS,
            headerTransparent: true,
          },
          header: useNewHeader ? () => <GameHeader /> : undefined,

          headerTitle: () => (
            <MainIcon
              handlePress={() => {
                dispatchAction(resetHomeView());
                navigationRef.navigate('LandingPageMain', {}, 'MainGameStack');
              }}
            />
          ),
          headerRight: () => {
            if (!isCurrentScreenGameLobby) {
              return <ClassicHuntHeaderTimer />;
            } else {
              return <FoxShopIcon />;
            }
          },
        })}>
        <Tab.Screen
          name={'HuntLoading'}
          options={{title: 'home!'}}
          component={HuntLoadingWrapper}
        />
        <Tab.Screen
          name="ScavengerHuntGameLobby"
          component={ScavengerHuntGameLobbyWrapper}
          options={{unmountOnBlur: true}}
        />

        <Tab.Screen
          name="ScavengerHuntCharacterSelection"
          component={ScavengerHuntCharacterSelectionWrapper}
          options={{unmountOnBlur: true}}
        />
        <Tab.Screen
          name="HuntIntro"
          component={HuntIntroWrapper}
          options={{unmountOnBlur: true}}
        />
        <Tab.Screen
          name="NavigationChallenge"
          component={NavigationChallengeWrapper}
          options={{unmountOnBlur: true}}
        />
        <Tab.Screen
          name="NavigationScore"
          component={NavigationScoreWrapper}
          options={{unmountOnBlur: true}}
        />
        <Tab.Screen
          name="LocationOutro"
          component={LocationOutroWrapper}
          options={{unmountOnBlur: true}}
        />
        <Tab.Screen
          name="ClassicChallenges"
          component={ClassicChallengesWrapper}
          options={{unmountOnBlur: true}}
        />
        <Tab.Screen
          name="ClassicIntro"
          component={HuntIntroWrapper}
          options={{unmountOnBlur: true}}
        />
        <Tab.Screen
          name="LocationComplete"
          component={LocationCompleteWrapper}
          options={{unmountOnBlur: true}}
        />
        <Tab.Screen
          name="LocationChallenges"
          component={LocationChallengeWrapper}
          options={{unmountOnBlur: true}}
        />
        <Tab.Screen
          name="LocationChallengeScore"
          component={LocationChallengeScoreWrapper}
          options={{unmountOnBlur: true}}
        />
        <Tab.Screen
          name="HuntOutro"
          component={HuntOutroWrapper}
          options={{unmountOnBlur: true}}
        />
        <Tab.Screen
          name={'TeamPhoto'}
          options={{title: 'home!', unmountOnBlur: true}}
          component={TeamPhotoWrapper}
        />
        <Tab.Screen
          name={'HuntFinished'}
          options={{title: 'home!', unmountOnBlur: true}}
          component={HuntFinished}
        />
        <Tab.Screen
          name={'HuntPostCard'}
          options={{title: 'home!', unmountOnBlur: true}}
          component={HuntPostCardWrapper}
        />
        <Tab.Screen
          name={'HuntFinishedPlayer'}
          options={{title: 'home!', unmountOnBlur: true}}
          component={HuntFinishedPlayerWrapper}
        />
        <Tab.Screen
          name={'HuntPhotos'}
          options={{title: 'home!', unmountOnBlur: true}}
          component={HuntPhotosWrapper}
        />

        <Tab.Screen
          name={'PlayerTreasureChallenges'}
          options={{title: 'home!', unmountOnBlur: true}}
          component={PlayerTreasureChallengesWrapper}
        />

        <Tab.Group screenOptions={{presentation: 'modal'}}>
          <Tab.Screen
            name={'PlayerDashboard_v2'}
            options={{title: 'home!', unmountOnBlur: true}}
            component={PlayerDashWrapper}
          />
          <Tab.Screen
            name={'FullScreenNavigationHelpModal'}
            options={{title: 'home!', unmountOnBlur: true}}
            component={FullScreenNavigationHelpModalWrapper}
          />
          <Tab.Screen
            name="HuntPostCardAddressConfirm"
            component={HuntPostCardAddressConfirm}
          />
          <Tab.Screen
            name="GameLobbyPlayersModal"
            component={GameLobbyPlayerModal}
          />
          <Tab.Screen name="HuntPaused" component={HuntPaused} />
        </Tab.Group>
      </Tab.Navigator>
      <MainGameController />
    </View>
  );
}
